<button mat-icon-button
  type="button"
  class="mat-elevation-z1 color-picker-button"
  [matMenuTriggerFor]="colorMenu"
  (menuOpened)="onMenuOpen()"
  [ngClass]="'mat-'+selectedPalette+'-'+selectedHue+'-bg'"
  [style.background-color]="userColor || 'transparent'">
  <mat-icon>palette</mat-icon>
</button>

<mat-menu #colorMenu="matMenu" class="fuse-material-color-picker-menu">

  <header [ngClass]="selectedColor?.class || 'mat-accent-bg'"
    class="mat-elevation-z4"
    fxLayout="row"
    fxLayoutAlign="space-between center">

    <button mat-icon-button
      [style.visibility]="view==='hues'?'visible':'hidden'"
      (click)="$event.stopPropagation();backToPaletteSelection()" aria-label="Palette">
      <mat-icon class="s-20">arrow_back</mat-icon>
    </button>

    @if (selectedColor?.palette) {
      <span>
        {{selectedColor.palette}} {{selectedColor.hue}}
      </span>
    }

    @if (!selectedColor?.palette) {
      <span>
        Select Color
      </span>
    }

    <button mat-icon-button
      class="remove-color-button"
      (click)="removeColor()"
      aria-label="Remove Color">
      <mat-icon class="s-20">delete</mat-icon>
    </button>
  </header>


  <div class="views">
    @switch (view) {
      @case ('palettes') {
        <div class="view"
          [@slideInLeft]>
          <div fxLayout="row wrap"
            fxLayoutAlign="start start"
            class="colors">
            @for (color of (colors | keys); track color) {
              <div class="color"
                [ngClass]="'mat-'+color.key+'-bg'"
                (click)="$event.stopPropagation();selectPalette(color.key)"
                fxLayout="row" fxLayoutAlign="start end" mat-ink-ripple>
                <span class="label">
                  {{color.key}}
                </span>
              </div>
            }
          </div>
        </div>
      }
      @case ('hues') {
        <div class="view"
          [@slideInRight]>
          <div fxLayout="row wrap"
            fxLayoutAlign="start start"
            class="colors" fusePerfectScrollbar>
            @for (hue of hues; track hue) {
              <div class="color"
                [fxHide]="selectedPalette === 'white' && hue !== '500'|| selectedPalette === 'black' && hue !== '500'"
                [ngClass]="'mat-'+selectedPalette+'-'+hue+'-bg'"
                (click)="selectHue(hue)"
                fxLayout="row" fxLayoutAlign="start end" mat-ink-ripple>
                <span class="label">
                  {{hue}}
                </span>
                @if (selectedHue === hue) {
                  <mat-icon class="s-16">check</mat-icon>
                }
              </div>
            }
          </div>
        </div>
      }
    }
  </div>
</mat-menu>
